<div class="search-result-container" (scroll)="checkScrollEnd($event)">
    <div class="list-result" *ngFor="let result of results" (click)="onResultClick.emit(result)">
        <div class="image-container">
            <img [src]="result.Picture_URL_OD" [alt]="result.Picture_Alt_OD" (error)="onImageError($event)"
                [ngStyle]="{'height': imageHeight, 'aspect-ratio': imageRatio}">
        </div>
        <div class="data-container">
            <div class="title-container">
                <p>{{ result.Topic_OD }}</p>
                <div class="meta-container">
                    <div class="source-data">
                        <div class="link">
                            <!-- <img [src]="result.icon" alt="source_icon">
                            <p>{{ result.sourceName }}</p> -->
                            <p *ngIf="nameDateConnect" style="font-size: 16px;" class="date">{{ (+result.PublishDate_OD)
                                * 1000 | date:'dd MMMM yyyy HH:mm' }}</p>
                        </div>
                        <p *ngIf="!nameDateConnect" class="date">{{ (+result.PublishDate_OD) * 1000 | date:'dd MMMM yyyy
                            HH:mm' }}</p>
                        <div class="meta-data-container">
                            <i [ngClass]="{
                                'pi-thumbs-up-fill text-success': result.SentimentLabel === 'pos',
                                'pi-minus-circle text-warning': result.SentimentLabel === 'neu',
                                'pi-thumbs-down-fill text-danger': result.SentimentLabel === 'neg'
                            }" class="pi text-3xl" pTooltip="{{ getSentimentTooltip(result.SentimentResults) }}">
                            </i>
                            <div class="views-container">
                                <img [src]="view_icon" alt="view_icon">
                                <p>{{ fastService.getFormatViews(result.Views) | number: '1.0-1' }}<span
                                        *ngIf="result.Views  >= 1000">K</span></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="description-container">
                <p class="description" [ngStyle]="{'-webkit-line-clamp': descriptionLines}">{{ result.Detail_OD }}</p>
            </div>
            <div class="mapBtn-container">
                <p-button *ngIf="showMapButton" [disabled]="result.LAT_LON_List == null" [text]="true" [rounded]="true"
                    label="แสดงตำแหน่งบนแผนที่" (onClick)="onMapButtonClick.emit(result)" icon="mapIcon"></p-button>
            </div>
        </div>
        <div class="corner-icon" style="display: flex;">
            <div style="display: flex; position: relative; width: fit-content; height: fit-content;">
                <img src="assets/navbar-component-images/banner.svg" alt="banner.svg">
                <img src="assets/navbar-component-images/bannerVector.svg" alt="bannerVector.svg"
                    style="position: absolute; left: 35%; top: 17%;">
            </div>
        </div>

    </div>
    <div class="list-skeleton" style="flex: 1" [ngClass]="{'hidden': !loading || !skeleton || reachTheEnd}"
        *ngFor="let index of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]">
        <div>
            <p-skeleton width="100%" height="100%"></p-skeleton>
        </div>
        <div>
            <div><p-skeleton width="100%" height="100%"></p-skeleton></div>
            <div>
                <p-skeleton width="100%" height="20%"></p-skeleton>
                <p-skeleton width="100%" height="20%"></p-skeleton>
                <p-skeleton width="80%" height="20%"></p-skeleton>
            </div>
        </div>
    </div>
    <div class="progressSpinnerContainer" *ngIf="loading && !skeleton && !reachTheEnd">
        <p-progressSpinner ariaLabel="loading" strokeWidth="4"></p-progressSpinner>
    </div>
    <div class="more-button-container" *ngIf="!loading && showMoreButton && !reachTheEnd && results.length">
        <p-button label="Read more" (onClick)="onRequestMoreSearchResults.emit()" [outlined]="true"
            [style]="{'padding': '0.5rem 1rem'}"></p-button>
    </div>
</div>